module.exports = __webpack_public_path__ + "img/banner1.5191d2c9.png";